import {StrictMode, lazy, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
// Витрина внутри карточки Битрикса (#654) — отдельная ветка рендера, а не вкладка
// кабинета: у неё свой вход (одноразовый тикет) и свой жизненный цикл. lazy, чтобы
// код виджета не попадал в главный бандл: его грузят единицы, а платили бы все.
const WidgetFrame = lazy(() => import('./components/WidgetFrame.tsx'));
import './index.css';
import { bootUpdateGuards } from './utils/appUpdate';
import { installViewportVars } from './utils/viewport';
import { installClientErrorReporter } from './utils/clientErrors';

// До рендера: во встроенном браузере Telegram/MAX — без service worker'а; после выкатки
// «потерянный» чанк раздела → перезагрузка на новую версию (utils/appUpdate.ts).
bootUpdateGuards();
// Реальная видимая высота (клавиатура, панели браузера) → --app-vvh для окон на весь экран.
installViewportVars();
// Ошибки интерфейса — на бэкенд (метрики мобильной версии, M-71).
installClientErrorReporter();

// Путь задаёт nginx (SPA-фолбэк), роутера в проекте нет — смотрим pathname напрямую.
const isWidget = window.location.pathname.startsWith('/widget/');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isWidget
      ? <Suspense fallback={null}><WidgetFrame /></Suspense>
      : <App />}
  </StrictMode>,
);
